module.exports = __webpack_public_path__ + "static/aragon-6ab7b6e2b46a62ab3e9593298a0929ce.png";